export class Template {
    public id: string;
    public name: string;
    public displayName: string;
    public url: string;
    public release: string;
    public locale: string;
    public localeId: string; // raw locale document ID, used for edit pre-selection
    public language: string;
    public softwareType: string;
    public preset: string;
    public softwareVersion: string;
    public published: boolean;
    public createdAt: Date;
    public updatedAt: Date;
}
